<script lang="ts">
  import { Icon } from '@shared/ui/icon';

  import type { Quote } from '../types';

  export let data: Quote;
</script>

<blockquote
  class="relative my-4 text-2xl font-medium md:flex md:gap-5 md:text-4xl [&>a]:font-medium [&>a]:underline [&>a]:decoration-black/50 dark:[&>a]:decoration-white/50"
>
  <Icon name="quotes" classes="text-default-320 md:h-10 md:w-10 w-8 h-8 rotate-180 mb-4" />

  <div>
    <!-- eslint-disable-next-line -->
    <p>{@html data.text}</p>

    <footer
      class="text-default-500 mt-3 text-sm font-medium [&>a]:font-medium [&>a]:underline [&>a]:decoration-black/50 dark:[&>a]:decoration-white/50"
    >
      <!-- eslint-disable-next-line -->
      — {@html data.caption}
    </footer>
  </div>
</blockquote>
